module.exports = __webpack_public_path__ + "img/svg/result-winner-button-background.ae2e01282bc5b63c15516dfdbdd5e05d.svg";